/* Opinew – ajustes de UX (NaturalSlim USA, 2026-09-24)
   1) Oculta miniaturas de reseñas cuya imagen falla o es un pixel 1x1
      (reseñas importadas de Amazon sin foto).
   2) Mientras las reseñas están en pantalla, esconde la burbuja proactiva
      del chat (#mtb-teaser) para que no tape el texto. El botón del chat
      sigue visible y la burbuja vuelve al salir de las reseñas. */
(function () {
  "use strict";

  // Parser-present metadata is corrected before the provider's later ordered-defer script.
  var language = (document.documentElement.lang || "").toLowerCase().split(/[-_]/)[0];
  if (language === "en" || language === "es") {
    var configElement = document.querySelector("#opinew_config_container[data-opwconfig]");
    if (configElement) {
      try {
        var config = JSON.parse(configElement.getAttribute("data-opwconfig"));
        if (config && typeof config === "object" && !Array.isArray(config) &&
            Object.prototype.hasOwnProperty.call(config, "preferred_language") &&
            config.preferred_language !== language) {
          config.preferred_language = language;
          configElement.setAttribute("data-opwconfig", JSON.stringify(config));
        }
      } catch (e) { /* Leave malformed provider metadata unchanged. */ }
    }
  }
  var SCOPE = '[id^="opinew_"][id$="_plugin_app"], .opw-generic-modal';

  function hide(img) {
    var box = img.closest(".opw-square-thumb, .opw-new-card-thumbs > *, a") || img;
    if (!box.closest(SCOPE)) box = img;
    box.classList.add("opw-img-broken");
  }
  function check(e) {
    var img = e.target;
    if (!img || img.tagName !== "IMG" || !img.closest(SCOPE)) return;
    if (e.type === "error" || (img.naturalWidth <= 1 && img.naturalHeight <= 1)) hide(img);
  }
  document.addEventListener("error", check, true);
  document.addEventListener("load", check, true);

  if (!("IntersectionObserver" in window)) return;
  var visibles = new Set();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) visibles.add(entry.target);
      else visibles.delete(entry.target);
    });
    document.documentElement.classList.toggle("opw-reading", visibles.size > 0);
  }, { rootMargin: "-20% 0px -20% 0px" });
  function observe() {
    document.querySelectorAll('[id^="opinew_"][id$="_plugin_app"]').forEach(function (el) {
      if (el.id.indexOf("product") !== -1 || el.id.indexOf("reviews") !== -1) io.observe(el);
    });
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", observe);
  else observe();
})();
